<template>
  <!-- <basic-container > -->
  <div class="card-container" style="background: #fff">
    <el-button-group>
      <el-button class="healthButton" @click="click(2)">数据总览</el-button>
      <!-- <el-button :class="healthButton == 2 ? 'healthButton healthActive' : 'healthButton'" @click="click(2)">数据总览</el-button>
      <el-button :class="healthButton == 1 ? 'healthButton healthActive' : 'healthButton'" @click="click(1)">数据中心</el-button> -->
    </el-button-group>

    <el-button-group style="margin-left: 1vw">
      <el-button :class="dateRange == 0 ? 'healthButton healthActive' : 'healthButton'" @click="changeDateRange(0)">全部</el-button>
      <el-button :class="dateRange == 1 ? 'healthButton healthActive' : 'healthButton'" @click="changeDateRange(1)">年</el-button>
      <el-button :class="dateRange == 2 ? 'healthButton healthActive' : 'healthButton'" @click="changeDateRange(2)">月</el-button>
      <el-button :class="dateRange == 3 ? 'healthButton healthActive' : 'healthButton'" @click="changeDateRange(3)">日</el-button>

      <el-date-picker v-model="motionDate" type="date" placeholder="选择日期时间" value-format="yyyy-MM-dd" @change="changeDateRange(4)" />
    </el-button-group>

    <div v-if="healthButton === 1">
      <div class="card-row">
        <div class="card card-20">
          <!-- <div style="font-size: 15px; font-weight: 600">概况统计</div>
        <div class="card-row" style="height: 12vh; margin-top: 1vh">
          <div class="card-header">
            <div class="card-total" style="float: left">总计<br />人数</div>
            <div style="float: right">1662<span>人</span><br />累计注册人数</div>
          </div>
        </div> -->
          <div class="card-row" style="height: 16vh"></div>
        </div>
        <div class="card card-50" style="position: relative">
          <el-button-group class="chart-buttons">
            <el-button :type="isSelected === 1 ? 'success' : 'default'" @click="isSelected = 1">日</el-button>
            <el-button :type="isSelected === 2 ? 'success' : 'default'" @click="isSelected = 2">月</el-button>
            <el-button :type="isSelected === 3 ? 'success' : 'default'" @click="isSelected = 3">年</el-button>
            <el-date-picker v-model="date1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="margin-left: 1vw"> </el-date-picker>
          </el-button-group>
          <div id="columnChart1" :style="{ width: '100%', height: '40vh' }"></div>
        </div>
        <div class="card card-20">
          <div id="pieChart1" :style="{ width: '100%', height: '40vh' }"></div>
        </div>
      </div>
      <div class="card-row">
        <div class="card card-20">
          <div id="columnChart2" :style="{ width: '100%', height: '40vh' }"></div>
        </div>
        <div class="card card-20">
          <div id="pieChart2" :style="{ width: '100%', height: '40vh' }"></div>
        </div>
        <div class="card card-50" style="position: relative">
          <div id="lineChart1" :style="{ width: '100%', height: '40vh' }"></div>
        </div>
      </div>
    </div>

    <div v-if="healthButton === 2" class="dashboard-container">
      <div class="cards-wrapper">
        <div class="card-container">
          <div v-for="(item, index) in option.data" :key="'opt1-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0001.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0002.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0003.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div v-for="(item, index) in option2.data" :key="'opt2-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0004.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0005.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0006.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div v-for="(item, index) in option3.data" :key="'opt3-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0007.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0008.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0009.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>

        <div class="card-container">
          <div v-for="(item, index) in option4.data" :key="'opt4-' + index" class="custom-card" :style="{ borderTop: `3px solid ${getCardColor(index)}` }" @click="item.click && item.click(item)">
            <h2>{{ item.title }}</h2>
            <p :style="{ color: getCardColor(index) }" :data-note="item.note">
              <img v-if="index === 0" src="@/page/login/images/0010.png" class="count-icon" alt="icon" />
              <img v-if="index === 1" src="@/page/login/images/0011.png" class="count-icon" alt="icon" />
              <img v-if="index === 2" src="@/page/login/images/0012.png" class="count-icon" alt="icon" />
              {{ item.count }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </basic-container> -->
</template>

<script>
import { getDataStatistic } from "@/api/health/manage";

export default {
  name: "ThreeCardLayout",
  data() {
    return {
      channel: window.localStorage.getItem("channel"),
      motionDate: "",
      healthButton: 2,
      dateRange: 0,
      isSelected: 1,
      list: [
        { b: 0, c: 0 },
        // { b: 0, c: 3 },
        // { b: 0, c: 4 },
        // { b: 0, c: 6 },
        // { b: 0, c: 10 },
        // { b: 0, c: 0 },
        // { b: 0, c: 0 },
        // { b: 4, c: 35 },
        // { b: 19, c: 43 },
        // { b: 9, c: 32 },
        // { b: 19, c: 20 },
        // { b: 15, c: 17 },
        // { b: 0, c: 0 },
        // { b: 0, c: 0 },
        // { b: 18, c: 12 },
        // { b: 7, c: 15 },
        // { b: 8, c: 2 },
        // { b: 4, c: 5 },
      ],
      date1: [],

      option: {
        data: [
          {
            title: "服务总人数",
            count: 0,
            note: "人",
          },
          {
            title: "服务总人次",
            count: 0,
            note: "人次",
          },
          {
            title: "锻炼人次",
            count: 0,
            note: "人次",
          },
        ],
      },
      option2: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "检测人次",
            count: 0,
            note: "人次",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "标准运动处方数",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "有氧运动处方数",
            count: 0,
            note: "个",
          },
        ],
      },
      option3: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "力量运动处方数",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "干预人次",
            count: 0,
            note: "人次",
          },
          {
            click: function (item) {
              alert("开发中");
            },
            title: "干预人数",
            count: 0,
            note: "人",
          },
        ],
      },
      option4: {
        data: [
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "营养处方数",
            count: 0,
            note: "个",
          },
          {
            // click: function (item) {
            //   alert("开发中");
            // },
            title: "体适能检测人次",
            count: 0,
            note: "人次",
          },
          {
            click: function (item) {
              alert("开发中");
            },
            title: "老年健康评估人次",
            count: 0,
            note: "人次",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.onload();
    this.columnChart1();
    this.pieChart1();
    this.columnChart2();
    this.lineChart1();
    this.pieChart2();
  },
  methods: {
    onload() {
      this.getDataStatistic(this.channel);
    },

    getDataStatistic(dateRange, channel) {
      const params = {
        aiIndex: 2,
        channel: channel,
        dateRange: Number(dateRange),
      };
      getDataStatistic(params).then((res) => {
        console.log(res.data);
        this.option.data[0].count = res.data.servicePersonCount;
        this.option.data[1].count = res.data.servicePersonNum;
        this.option.data[2].count = res.data.motionCount;
        this.option2.data[1].count = res.data.exerciseSchemeCount;
        this.option3.data[1].count = res.data.servicePersonNum;
        this.option3.data[2].count = res.data.interveneCount;
        this.option4.data[0].count = res.data.nutritionSchemeCount;
      });
    },

    getDataStatisticByParams(params) {
      getDataStatistic(params).then((res) => {
        console.log(res.data);
        this.option.data[0].count = res.data.servicePersonCount;
        this.option.data[1].count = res.data.servicePersonNum;
        this.option.data[2].count = res.data.motionCount;
        this.option2.data[1].count = res.data.exerciseSchemeCount;
        this.option3.data[1].count = res.data.servicePersonNum;
        this.option3.data[2].count = res.data.interveneCount;
        this.option4.data[0].count = res.data.nutritionSchemeCount;
      });
    },

    changeDateRange(index) {
      this.dateRange = index;
      const params = {
        aiIndex: 2,
        channel: this.channel,
        // dateRange: Number(this.dateRange),
      };
      if (this.dateRange === 4) {
        const startDate = this.motionDate;
        const endDate = this.getEndDate(startDate);
        params.startDate = startDate;
        params.endDate = endDate;
        this.getDataStatisticByParams(params);
      } else {
        params.dateRange = Number(this.dateRange);
        this.getDataStatisticByParams(params);
      }
    },

    getEndDate(startDate) {
      const dateObj = new Date(startDate);
      dateObj.setDate(dateObj.getDate() + 1);
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const day = String(dateObj.getDate()).padStart(2, "0");
      const endDate = `${year}-${month}-${day}`;
      return endDate;
    },

    // 动态获取卡片颜色（按顺序循环）
    getCardColor(index) {
      const colors = ["rgb(255, 255, 255)", "rgb(255, 255, 255)", "rgb(255, 255, 255)"];
      return colors[index % colors.length];
    },

    columnChart1() {
      // 获取本月天数并生成日期数组
      const now = new Date();
      const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
      console.log(daysInMonth);
      const monthDays = Array.from({ length: daysInMonth + 1 }, (_, i) => `${i < 10 && i !== 0 ? "0" + i : i === 0 ? "" : i}`);

      // 准备数据
      const test = this.list.map((v) => v.b);
      const motion = this.list.map((v) => v.c);

      const myChart = this.$echarts.init(document.getElementById("columnChart1"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "测试人数&运动人数",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["测试人数", "运动人数"],
          left: "right",
          top: 30,
          itemWidth: 25,
          itemHeight: 14,
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: monthDays,
          axisLabel: {
            // 修改x轴标签
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10); // 取最大值 +10
          },
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "测试人数",
            type: "bar",
            data: test,
          },
          {
            name: "运动人数",
            type: "bar",
            data: motion,
          },
        ],
        color: ["#355CB0", "#E4B858"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    pieChart1() {
      const myChart = this.$echarts.init(document.getElementById("pieChart1"));
      const data = [
        { value: 0, name: "男性" },
        { value: 0, name: "女性" },
      ];

      const option = {
        title: {
          text: "测试人员性别分布",
          // subtext: "数据统计",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          top: "top",
          left: "right",
          data: ["男性", "女性"],
        },
        series: [
          {
            name: "性别比例",
            type: "pie",
            radius: ["30%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "bottom",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "18",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data,
            color: ["#5470c6", "#ee6666"],
            // 圆角效果
            roundCap: true,
          },
        ],
        animation: true,
        animationDuration: 1000,
        animationEasing: "cubicInOut",
      };

      myChart.setOption(option);

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    columnChart2() {
      const myChart = this.$echarts.init(document.getElementById("columnChart2"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "力量&有氧处方等级分布",
          left: "left",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: "shadow",
          // },
        },
        legend: {
          data: ["力量处方", "有氧处方"],
          left: "center",
          bottom: "bottom",
          itemWidth: 25,
          itemHeight: 14,
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "value",
          boundaryGap: false,
          axisTick: {
            alignWithLabel: true,
          },
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10);
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        yAxis: {
          type: "category",
          data: ["", "差", "偏差", "中等", "良好", "优秀", ""],
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        series: [
          {
            name: "力量处方",
            type: "bar",
            // data: [0, 20, 32, 83, 114, 55],
          },
          {
            name: "有氧处方",
            type: "bar",
            // data: [0, 10, 42, 73, 100, 45],
          },
        ],
        color: ["#345ABB", "#78B64A"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    lineChart1() {
      const myChart = this.$echarts.init(document.getElementById("lineChart1"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "体型人数分布",
          left: "left",
          textStyle: {
            fontSize: 15,
            // fontWeight: "bold",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: false,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["", "低脂地体重", "低脂肌肉型", "运动员型", "低体重", "标准体型", "超重肌肉型", "隐形肥胖", "脂肪过载", "肥胖"],
          axisLabel: {
            // 修改x轴标签
            interval: 0,
            rotate: 0,
            margin: 7,
          },
          axisLine: {
            lineStyle: {
              // color: "#999",
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          min: 0,
          max: function (value) {
            return Math.max(Math.floor(value.max / 10) * 10 + 10); // 取最大值 +10
          },
          axisLabel: {
            formatter: "{value}",
          },
          axisLine: {
            show: false, // 不显示轴线
          },
        },
        series: [
          {
            name: "测试人数",
            type: "line",
            // data: [0, 3, 4, 0, 1, 25, 11, 0, 3, 16],
            stack: "总量",
            areaStyle: {},
          },
        ],
        color: ["#355CB0"],
      });

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    pieChart2() {
      const myChart = this.$echarts.init(document.getElementById("pieChart2"));
      const data = [
        { value: 0, name: "20岁以下" },
        { value: 0, name: "20-29岁" },
        { value: 0, name: "30-39岁" },
        { value: 0, name: "40-49岁" },
        { value: 0, name: "50-59岁" },
        { value: 0, name: "60-69岁" },
        { value: 0, name: "70-79岁" },
        { value: 0, name: "80岁以上" },
      ];

      const option = {
        title: {
          text: "年龄分布",
          left: "left",
          top: "top",
          textStyle: {
            fontSize: 15,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "年龄分布",
            type: "pie",
            radius: "65%",
            avoidLabelOverlap: true,
            center: ["50%", "50%"],
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 0,
            },
            label: {
              show: true,
              position: "right",
              color: "black",
              fontSize: 12,
              // verticalAlign: "middle",
              // distanceToLabelLine: 0,
              // padding: [5, 10],
              // backgroundColor: "rgba(255,255,255,0.8)",
              // borderColor: "#eee",
              // borderWidth: 1,
              // borderRadius: 4,
            },
            labelLine: {
              length: 15, // 第一段线长度
              length2: 10, // 第二段线长度
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            data: data,
            color: ["#355ABC", "#7BB05C", "#EAB83E", "#D74E52", "#55B9D9", "#21915D", "#EC7546", "#8A589D"],
            // 圆角效果
            roundCap: true,
          },
        ],
        animation: true,
        animationDuration: 1000,
        animationEasing: "cubicInOut",
      };

      myChart.setOption(option);

      // 响应式调整
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    click(index) {
      this.healthButton = index;
      if (index === 1) {
        setTimeout(() => {
          this.columnChart1();
          this.pieChart1();
          this.columnChart2();
          this.lineChart1();
          this.pieChart2();
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 1vw;
  box-sizing: border-box;
}

.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vw;
  gap: 1vw;
}

.card {
  background: #fff;
  /* border-radius: 8px; */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card-50 {
  flex: 1 1 calc(40% - 1vw); /* 50%宽度减去gap */
  height: 43vh;
}

.card-20 {
  flex: 1 1 calc(20% - 1vw); /* 20%宽度减去gap */
  height: 43vh;
}

.chart-buttons {
  position: absolute;
  top: 0.5vw; /* 距离顶部距离 */
  right: 1vw; /* 距离右侧距离 */
  z-index: 100; /* 确保按钮在图表上方 */
  opacity: 0.9; /* 可选：轻微透明效果 */
  width: auto;
}

.card-header {
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-total {
  font-size: 24px;
  font-weight: 600;
  margin-top: 8px;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}

.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>

<style scoped lang="scss">
.dashboard-container {
  height: 85vh;
  display: flex;
  flex-direction: column;

  .basic-container {
    flex: 1;
    padding: 2vh 2vw; /* 使用视口单位 */
    display: flex;
    flex-direction: column;
    background: transparent; /* 确保容器背景透明 */
  }

  .cards-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0vh 0; /* 添加一些内边距 */
    gap: 5vh;
  }

  .card-container {
    display: flex;
    gap: 8vw;
    flex: 1;
    min-height: 0;
    padding: 1vh 0;
    justify-content: center;
  }

  .custom-card {
    flex: 1;
    // max-width: 300px; /* 限制卡片最大宽度 */
    min-width: 180px; /* 设置最小宽度 */
    background: #fff;
    border-radius: 4px;
    padding: 2vh 2vw; /* 使用视口单位 */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.3s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1); // 悬停时阴影加深
    }

    h2 {
      /* 修正选择器从h3改为h2以匹配模板 */
      font-size: clamp(14px, 1.5vh, 18px); /* 使用clamp函数设置响应式字体 */
      margin-bottom: 15px;
      color: #000000;
    }

    p {
      display: flex;
      align-items: center;
      gap: 2vw; /* 使用视口单位 */
      font-size: clamp(24px, 4vh, 44px); /* 响应式字体大小 */
      font-weight: bold;
      margin: 0;
      color: #000 !important; /* 数字改为黑色，使用important覆盖内联样式 */

      &::after {
        content: attr(data-note); /* 从data-note属性获取内容 */
        font-size: clamp(14px, 2vh, 25px);
        margin-left: 1px;
        font-weight: normal;
        color: #000000;
      }
    }

    .count-icon {
      width: clamp(40px, 6vh, 80px); /* 响应式图标大小 */
      height: clamp(40px, 6vh, 80px);
      object-fit: contain;
    }
  }
}
</style>
